module Sm.Core.Option

module Operators =
    let inline ( <!> ) x f = Option.map f x
    let inline ( >>= ) x f = Option.bind f x
    let inline ( <??> ) x v = Option.defaultValue v x

type MaybeBuilder() =
    member inline _.Bind(x, f) = Option.bind f x
    member inline _.Zero() = Some ()
    member inline _.Return(x) = Some x
    member inline _.ReturnFrom(x) = x

let maybe = MaybeBuilder()

let traverse f items =
    (items, Some List.empty)
    ||> List.foldBack (fun item items -> maybe {
        let! x = f item
        let! xs = items
        return x :: xs
    })

let sequence items =
    items |> traverse id
